import React, { useState, useEffect } from "react";
import { Loader2 } from "lucide-react";

const LOADING_MESSAGES = [
  { title: "Analyzing your market position...", subtitle: "Scanning competitive landscape" },
  { title: "Building your brand strategy...", subtitle: "Crafting unique positioning" },
  { title: "Reviewing Google Business data...", subtitle: "Analyzing reviews and ratings" },
  { title: "Generating marketing tactics...", subtitle: "Creating actionable campaigns" },
  { title: "Building marketing strategies...", subtitle: "Creating actionable campaign ideas" },
  { title: "Compiling your report...", subtitle: "Almost there!" },
];

export const ReportLoading = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const currentMessage = LOADING_MESSAGES[messageIndex];

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950">
      <div className="text-center max-w-md">
        <Loader2 className="w-16 h-16 animate-spin text-emerald-400 mx-auto mb-6" />
        <h2 className="text-xl font-bold text-white mb-2">{currentMessage.title}</h2>
        <p className="text-slate-400 mb-6">{currentMessage.subtitle}</p>
        <div className="w-full bg-slate-800 rounded-full h-2">
          <div className="bg-emerald-400 h-2 rounded-full transition-all duration-1000"
            style={{ width: `${Math.min(15 + messageIndex * 15, 95)}%` }} />
        </div>
        <p className="text-slate-500 text-sm mt-4">
          This typically takes 1-2 minutes. Auto-refreshing...
        </p>
      </div>
    </div>
  );
};
